import { render, staticRenderFns } from "./Vimeos.vue?vue&type=template&id=07abcb30&scoped=true&"
import script from "./Vimeos.vue?vue&type=script&lang=js&"
export * from "./Vimeos.vue?vue&type=script&lang=js&"
import style0 from "./Vimeos.vue?vue&type=style&index=0&id=07abcb30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abcb30",
  null
  
)

export default component.exports